import { render, staticRenderFns } from "./ArticleContribute.vue?vue&type=template&id=7b0699bd&scoped=true&"
import script from "./ArticleContribute.vue?vue&type=script&lang=ts&"
export * from "./ArticleContribute.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleContribute.vue?vue&type=style&index=0&id=7b0699bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0699bd",
  null
  
)

export default component.exports